<template>
  <div id="querys" v-show="$store.state.global_privilegio_consulta.ver">
    <div class="container-fluid mt-3">
      <div class="container-fluid">
        <div class="pl-2 pr-2 pb-2">
          <div class="box-body bg-light matriz-peligro-content col-md-12">
            <div class="collapse show" id="mmr-collapse">
              <div class="row pb-3">
                <div class="col-md-9">
                  <label class="color_letra mt-3"
                    >Grupo de Exposición Similar</label
                  >
                  <select
                    class="form-control boton_texto"
                    v-model="sector_existente"
                  >
                    <option value="" selected disabled="disabled">Grupo</option>
                    <option v-for="item of mostrar_sector" :key="item.sector">
                      {{ item.sector }}
                    </option>
                    <option value="">Todos</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Regional</label>
                  <select
                    class="form-control boton_texto"
                    v-model="regional_existente"
                    @change="datos_departamento_filtro($event)"
                  >
                    <option value="" selected disabled="disabled">
                      Regional
                    </option>
                    <option
                      v-for="item2 of mostrar_regional"
                      :value="item2.regional"
                      :key="item2.regional"
                    >
                      {{ item2.regional }}
                    </option>
                    <option value="">Todos</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Departamento</label>
                  <template v-if="regional_existente == ''">
                    <select
                      class="form-control boton_texto"
                      v-model="departamento_existente"
                    >
                      <option value="" selected disabled="disabled">
                        Departamento
                      </option>
                      <option
                        v-for="item of mostrar_departamento"
                        :key="item.departamento"
                      >
                        {{ item.departamento }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </template>
                  <template v-else>
                    <select
                      class="form-control boton_texto"
                      v-model="departamento_existente"
                      @change="datos_ciudades_filtro($event)"
                    >
                      <option value="" selected disabled="disabled">
                        Departamento
                      </option>
                      <option
                        v-for="item of mostrar_departamento"
                        :key="item.departamentos"
                      >
                        {{ item.departamentos }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </template>
                </div>
                <div class="col-md-4">
                  <label class="color_letra mt-3">Ciudades</label>
                  <template v-if="departamento_existente == ''">
                    <select
                      class="form-control boton_texto"
                      v-model="ciudades_existente"
                    >
                      <option value="" selected disabled="disabled">
                        Sector
                      </option>
                      <option
                        v-for="item of mostrar_ciudades"
                        :key="item.ciudad"
                      >
                        {{ item.ciudad }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </template>
                  <template v-else>
                    <select
                      class="form-control boton_texto"
                      v-model="ciudades_existente"
                    >
                      <option value="" selected disabled="disabled">
                        Sectores
                      </option>
                      <option
                        v-for="item of mostrar_ciudades"
                        :key="item.ciudad"
                      >
                        {{ item.ciudad }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </template>
                </div>
                <div class="col-md-9">
                  <label class="color_letra mt-3">Clientes</label>
                  <select
                    class="form-control boton_texto"
                    v-model="clientes_existente"
                  >
                    <option value="" selected disabled="disabled">
                      Cliente
                    </option>
                    <option
                      v-for="item of mostrar_clientes"
                      :value="item.key"
                      :key="item.cliente"
                    >
                      {{ item.cliente }}
                    </option>
                    <option value="">Todos</option>
                  </select>
                </div>
                <div class="col-md-12 clearfix p-3">
                  <button
                    type="button"
                    class="btn btn-secondary float-left rounded-pill"
                    @click="
                      consulta_priorizada = false;
                      bonton_priorizar = true;
                      tabla_matrices(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      );
                    "
                  >
                    CONSULTAR
                  </button>
                  <button
                    v-if="
                      sector_existente != '' ||
                      regional_existente != '' ||
                      departamento_existente != '' ||
                      ciudades_existente != '' ||
                      clientes_existente != ''
                    "
                    type="button"
                    class="btn btn_modal rounded-pill"
                    @click="limpiarConsulta()"
                  >
                    HACER NUEVA CONSULTA
                  </button>
                  <button
                    type="button"
                    class="btn btn-info float-right rounded-pill"
                    v-if="bonton_priorizar == true"
                    @click="
                      consulta_priorizada = true;
                      consulta_general_no_aceptable(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      );
                    "
                  >
                    PRIORIZAR
                  </button>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end m-0 p-0">
              <a
                @click="collapsed = !collapsed"
                class="pb-0 mb-0"
                data-toggle="collapse"
                data-target="#mmr-collapse"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                <i
                  :class="[
                    collapsed ? 'fa-chevron-up' : 'fa-chevron-down',
                    'fa',
                  ]"
                ></i>
              </a>
            </div>
          </div>
        </div>

        <div
          v-if="consulta_priorizada == false && lista_clientes.length > 0"
          class="table-responsive table_lista mb-3 p-2"
        >
          <v-client-table
            class="col-sm-12"
            :columns="columns"
            :data="lista_clientes"
            :options="options"
          >
            <div slot="opciones" slot-scope="props">
              <button
                :class="[props.row.completo]"
                data-toggle="dropdown"
                aria-expanded="false"
              ></button>
              <ul class="dropdown-menu boton_13" role="menu">
                <center>
                  <li>
                    <a
                      v-if="
                        $store.state.global_privilegio_consulta.excel == true
                      "
                      class="btn btn-block mi_boton pull-left boton_14"
                      data-toggle="modal"
                      data-target="#modal_mostrar_matriz"
                      @click="consultar_lista_clientes(props.row.id)"
                    >
                      &nbsp;<b>Ver Excel</b>
                    </a>
                    <p v-else>Sin Privilegios</p>
                  </li>
                </center>
              </ul>
            </div>
          </v-client-table>
        </div>
        <div
          v-else-if="consulta_priorizada == false && lista_clientes.length == 0"
          class="pl-2 pr-2 bg-light matriz-peligro-content col-md-12"
        >
          <p>No hay datos que mostrar</p>
        </div>

        <div
          v-if="bonton_priorizar == true && consulta_priorizada == true"
          class="table-responsive table_lista mb-3 p-3"
        >
          <div class="row justify-content-center">
            <div class="col-md-12 container bg-light rounded">
              <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item pr-1" role="presentation">
                  <a
                    class="nav-link active btn btn-outline-danger"
                    id="pills-home-tab"
                    data-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="false"
                    @click="
                      consulta_general_no_aceptable(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      )
                    "
                  >
                    No Aceptables</a
                  >
                </li>
                <li class="nav-item pr-1" role="presentation">
                  <a
                    class="nav-link btn btn-outline-warning"
                    id="pills-profile-tab"
                    data-toggle="pill"
                    href="#pills-profile"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                    @click="
                      consulta_general_aceptable_control(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      )
                    "
                  >
                    Aceptable con Control Específico</a
                  >
                </li>
                <li class="nav-item pr-1" role="presentation">
                  <a
                    class="nav-link btn btn-outline-success"
                    id="pills-contact-tab"
                    data-toggle="pill"
                    href="#pills-contact"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                    @click="
                      consulta_general_mejorable(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      )
                    "
                  >
                    Mejorable</a
                  >
                </li>
                <li class="nav-item pr-1" role="presentation">
                  <a
                    class="nav-link btn btn-outline-primary"
                    id="pills-messages-tab"
                    data-toggle="pill"
                    href="#pills-messages"
                    role="tab"
                    aria-controls="pills-messages"
                    aria-selected="false"
                    @click="
                      consulta_general_aceptable(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      )
                    "
                  >
                    Aceptables</a
                  >
                </li>
                <li class="nav-item pr-1" role="presentation">
                  <a
                    class="nav-link btn btn-outline-secondary"
                    id="pills-estadistica-tab"
                    data-toggle="pill"
                    href="#pills-estadistica"
                    role="tab"
                    aria-controls="pills-estadistica"
                    aria-selected="false"
                    @click="
                      grafica_matrices(
                        sector_existente,
                        regional_existente,
                        departamento_existente,
                        ciudades_existente,
                        clientes_existente
                      )
                    "
                  >
                    Estadísticas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div v-if="array_lista_peligros2.length > 0">
                    <v-client-table
                      :columns="columns2"
                      :data="array_lista_peligros2"
                      :options="options2"
                      class="table table-hover table-borderless dt-responsive"
                    >
                      <div slot="aceptabilidad">
                        <button type="button" class="btn btn-outline-danger">
                          No Aceptable
                        </button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <div v-if="array_lista_peligros3.length > 0">
                    <v-client-table
                      :columns="columns3"
                      :data="array_lista_peligros3"
                      :options="options3"
                      class="table table-hover table-borderless dt-responsive"
                    >
                      <div slot="aceptabilidad">
                        <button type="button" class="btn btn-outline-warning">
                          Aceptable con Control Específico
                        </button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-contact"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                >
                  <div v-if="array_lista_peligros4.length > 0">
                    <v-client-table
                      :columns="columns4"
                      :data="array_lista_peligros4"
                      :options="options4"
                      class="table table-hover table-borderless dt-responsive"
                    >
                      <div slot="aceptabilidad">
                        <button type="button" class="btn btn-outline-success">
                          Mejorable
                        </button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-messages"
                  role="tabpanel"
                  aria-labelledby="pills-messages-tab"
                >
                  <div v-if="array_lista_peligros5.length > 0">
                    <v-client-table
                      :columns="columns5"
                      :data="array_lista_peligros5"
                      :options="options5"
                      class="table table-hover table-borderless dt-responsive"
                    >
                      <div slot="aceptabilidad">
                        <button type="button" class="btn btn-outline-primary">
                          Aceptable
                        </button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-estadistica"
                  role="tabpanel"
                  aria-labelledby="pills-estadistica-tab"
                >
                  <div class="col-md-12 mb-4">
                    <h3
                      style="
                        text-align: center;
                        color: #878787;
                        font-size: 41pt;
                      "
                    >
                      GRÁFICA
                    </h3>
                    <h3
                      style="
                        text-align: center;
                        color: #878787;
                        font-size: 18pt;
                        margin-top: -15px;
                      "
                    >
                      TOTAL PELIGROS REGISTRADOS
                    </h3>
                    <div class="row justify-content-center">
                      <div class="col-md-4">
                        <p style="text-align: justify"></p>
                        <div id="peligros_grafica_matriz"></div>
                        <div style="color: rgb(0, 0, 0); text-align: center">
                          Total Peligros: <b id="total_peligros"></b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MODAL MOSTRAR MATRIZ -->
        <div
          class="modal fade"
          id="modal_mostrar_matriz"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Matriz</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="table-responsive" id="div1">
                  <table
                    class="table_excel"
                    bgcolor="#DADADA"
                    FRAME="void"
                    RULES="all"
                    id="myTable"
                  >
                    <thead>
                      <tr>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #85c1e9"
                        >
                          PROCESO
                        </th>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #85c1e9"
                        >
                          ZONA/LUGAR
                        </th>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #85c1e9"
                        >
                          ACTIVIDADES
                        </th>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #85c1e9"
                        >
                          TAREAS
                        </th>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #85c1e9"
                        >
                          TAREA RUTINARIO (SI O NO)
                        </th>
                        <th
                          colspan="2"
                          class="table_letra"
                          style="background-color: #f1948a"
                        >
                          PELIGRO
                        </th>
                        <th
                          rowspan="2"
                          class="table_letra"
                          style="background-color: #82e0aa"
                        >
                          EFECTOS POSIBLES
                        </th>
                        <th
                          colspan="3"
                          class="table_letra"
                          style="background-color: #eb984e"
                        >
                          CONTROLES EXISTENTES
                        </th>
                        <th
                          colspan="7"
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          EVALUACIÓN DEL RIESGO
                        </th>
                        <th
                          colspan="1"
                          class="table_letra"
                          style="background-color: #aed6f1"
                        >
                          VALORACIÓN DEL RIESGO
                        </th>
                        <th
                          colspan="2"
                          class="table_letra"
                          style="background-color: #d699cb"
                        >
                          CRITERIOS PARA ESTABLECER CONTROLES
                        </th>
                        <th
                          colspan="5"
                          class="table_letra"
                          style="background-color: #f5b041"
                        >
                          MEDIDAS DE INTERVENCIÓN
                        </th>
                      </tr>
                      <tr>
                        <th
                          class="table_letra"
                          style="background-color: #f1948a"
                        >
                          DESCRIPCIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #f1948a"
                        >
                          CLASIFICACIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #eb984e"
                        >
                          FUENTE
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #eb984e"
                        >
                          MEDIO
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #eb984e"
                        >
                          INDIVIDUO
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          NIVEL DE DEFICIENCIA
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          NIVEL DE EXPOSICIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          NIVEL DE PROBABILIDAD
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          INTERPRETACIÓN DEL NIVEL DE PROBABILIDAD
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          NIVEL DE CONSECUENCIA
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          NIVEL DE RIESGO (NR) E INTERVENCIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #99a3a4"
                        >
                          INTERPRETACIÓN DEL NR
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #aed6f1"
                        >
                          ACEPTABILIDAD DEL RIESGO
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #d699cb"
                        >
                          Nº EXPUESTOS
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #d699cb"
                        >
                          PEOR CONSECUENCIA
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #f5b041"
                        >
                          ELIMINACIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #f5b041"
                        >
                          SUSTITUCIÓN
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #f5b041"
                        >
                          CONTROLES DE INGENIERÍA
                        </th>
                        <th
                          class="table_letra"
                          style="background-color: #f5b041"
                        >
                          CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA
                        </th>
                        <th
                          class="table_letra col-7"
                          style="background-color: #f5b041"
                        >
                          EQUIPOS/ELEMENTOS DE PROTECCIÓN PERSONAL
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(usuario, index) of array_lista_peligros"
                        :key="index.usuario"
                        style="text-align: center"
                      >
                        <td>{{ usuario.proceso_riesgo }}</td>
                        <td>{{ usuario.zona }}</td>
                        <td>{{ usuario.actividades }}</td>
                        <td>
                          <div v-if="!Array.isArray(usuario.tareas)">
                            {{ usuario.tareas }}
                          </div>
                          <div
                            v-else
                            class="table-borderless justify-content-start"
                            v-for="(u_tarea, index) of usuario.tareas"
                            :key="index.u_tarea"
                          >
                            <span class="badge badge-info">{{
                              index + 1
                            }}</span>
                            {{ u_tarea }}
                          </div>
                        </td>
                        <td>{{ usuario.rutinario }}</td>
                        <td>{{ usuario.descripcion }}</td>
                        <td>
                          <div v-if="usuario.clasificacion != ''">
                            {{ usuario.clasificacion }}
                          </div>
                          <div v-if="usuario.tipo != ''">
                            {{ usuario.tipo }}
                          </div>
                          <div v-if="usuario.subti != ''">
                            {{ usuario.subti }}
                          </div>
                          <div v-if="usuario.otro_subti != ''">
                            {{ usuario.otro_subti }}
                          </div>
                        </td>
                        <td>
                          <div v-for="efecto in usuario.efectos" :key="efecto">
                            <p v-if="efecto != ''">{{ efecto }}</p>
                          </div>
                        </td>
                        <td>
                          <div
                            v-for="fuente in usuario.control_fuente"
                            :key="fuente"
                          >
                            <p v-if="fuente != ''">{{ fuente }}</p>
                          </div>
                        </td>
                        <td>
                          <div
                            v-for="medio in usuario.control_medio"
                            :key="medio"
                          >
                            <p v-if="medio != ''">{{ medio }}</p>
                          </div>
                        </td>
                        <td>
                          <div
                            v-for="individuo in usuario.control_individuo"
                            :key="individuo"
                          >
                            <p v-if="individuo != ''">{{ individuo }}</p>
                          </div>
                        </td>
                        <td>{{ usuario.nivel_eficiencia }}</td>
                        <td>{{ usuario.nivel_exposicion }}</td>
                        <td>{{ usuario.nivel_probabilidad }}</td>
                        <td>
                          <center>
                            <div
                              v-if="usuario.interpretacion != ''"
                              :class="usuario.class_btn_outline"
                              style="width: 85px"
                            >
                              {{ usuario.interpretacion }}
                            </div>
                          </center>
                        </td>
                        <td>{{ usuario.nivel_consecuencia }}</td>
                        <td>{{ usuario.nivel_riesgo }}</td>
                        <td>
                          <center>
                            <div
                              v-if="usuario.interpretacion_nr != ''"
                              class="btn btn-outline-primary"
                              readonly
                              style="width: 85px"
                            >
                              {{ usuario.interpretacion_nr }}
                            </div>
                          </center>
                        </td>
                        <td>
                          <div
                            v-if="usuario.aceptabilidad != ''"
                            :class="usuario.class_btn_alerts"
                            readonly
                            value=""
                          >
                            {{ usuario.aceptabilidad }}
                          </div>
                        </td>
                        <td>{{ usuario.num_expuestos }}</td>
                        <td>{{ usuario.peor_consecuencia }}</td>
                        <td>{{ usuario.eliminacion }}</td>
                        <td>{{ usuario.sustitucion }}</td>
                        <td>{{ usuario.controles_ing }}</td>
                        <td>{{ usuario.controles }}</td>
                        <td>{{ usuario.equipos }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  @click="proceso_copiar_matriz"
                  type="button"
                  class="btn boton_guardar"
                >
                  Copiar Matriz
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- MODAL PROCESO COPIAR -->
        <div class="tab-content pl-5 pr-5">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth } from "./../firebase";
const db = firebase.firestore();
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "querys",
  computed: {
    mostrar_sectorComputed() {
      return [
        ...new Map(
          this.mostrar_sector.map((item) => [item.sector, item])
        ).values(),
      ];
    },
    mostrar_regionalComputed() {
      return [
        ...new Map(
          this.mostrar_regional.map((item) => [item.regional, item])
        ).values(),
      ];
    },
    mostrar_departamentoComputed() {
      return [
        ...new Map(
          this.mostrar_departamento.map((item) => [item.departamento, item])
        ).values(),
      ];
    },
    mostrar_ciudadesComputed() {
      return [
        ...new Map(
          this.mostrar_ciudades.map((item) => [item.ciudad, item])
        ).values(),
      ];
    },
  },
  data() {
    return {
      collapsed: true,
      // CONSULTAR SECTOR EXISTENTE
      mostrar_sector: [],
      sector_existente: "",
      mostrar_regional: [],
      regional_existente: "",
      mostrar_departamento: [],
      departamento_existente: "",
      mostrar_ciudades: [],
      ciudades_existente: "",
      mostrar_clientes: [],
      clientes_existente: "",
      id_cliente: "",

      nuevo_valor: "",
      nuevo_valor_departamento: "",

      bonton_priorizar: false,
      consulta_priorizada: false,
      total_peligros_vue: "",

      lista_clientes: [],
      columns: [
        "empresa",
        "sector",
        "trabajo",
        "regional",
        "departamento",
        "ciudad",
        "opciones",
      ],
      options: {
        headings: {
          // NOMBRE DEL CLIENTE
          empresa: "Nombre Empresa",
          // SECTOR
          sector: "Sector",
          // CENTRO DE TRABAJO
          trabajo: "Centro de Trabajo",
          // REGIONAL
          regional: "Regional",
          departamento: "Departamento",
          ciudad: "Ciudad",
          opciones: "Opciones",
        },
        sortable: [
          "sector",
          "empresa",
          "trabajo",
          "regional",
          "departamento",
          "ciudad",
        ],
        texts: {
          filter: "Buscar",
          filterPlaceholder: " ",
        },
      },

      array_lista_peligros: [],
      array_lista_peligros2: [],
      array_lista_peligros3: [],
      array_lista_peligros4: [],
      array_lista_peligros5: [],

      // VARIABLES PARA LA TABLA NO ACEPTABLE
      array_lista_peligros2: [],
      columns2: [
        "clasificacion",
        "subclasificacion",
        "descripcion",
        "depar",
        "ciu",
        "centro",
        "num_expuestos",
      ],
      options2: {
        headings: {
          clasificacion: "RIESGO",
          subclasificacion: "SUBCLASIFICACIÓN",
          descripcion: "DESCRIPCIÓN",
          depar: "DEPARTAMENTO",
          ciu: "MUNICIPIO",
          centro: "CENTRO DE TRABAJO",
          num_expuestos: "EXPUESTOS",
        },
        sortable: [
          "clasificacion",
          "subclasificacion",
          "depar",
          "ciu",
          "centro",
          "num_expuestos",
        ],
        texts: {
          filter: "",
          filterPlaceholder: "Buscar... ",
        },
      },

      // VARIABLES PARA LA TABLA ACEPTABLE CON CONTROL ESPECÍFICO
      array_lista_peligros3: [],
      columns3: [
        "clasificacion",
        "subclasificacion",
        "descripcion",
        "depar",
        "ciu",
        "centro",
        "num_expuestos",
      ],
      options3: {
        headings: {
          clasificacion: "RIESGO",
          subclasificacion: "SUBCLASIFICACIÓN",
          descripcion: "DESCRIPCIÓN",
          depar: "DEPARTAMENTO",
          ciu: "MUNICIPIO",
          centro: "CENTRO DE TRABAJO",
          num_expuestos: "EXPUESTOS",
        },
        sortable: [
          "clasificacion",
          "subclasificacion",
          "depar",
          "ciu",
          "centro",
          "num_expuestos",
        ],
        texts: {
          filter: "",
          filterPlaceholder: "Buscar... ",
        },
      },

      // VARIABLES PARA LA TABLA MEJORABLE
      array_lista_peligros4: [],
      columns4: [
        "clasificacion",
        "subclasificacion",
        "descripcion",
        "depar",
        "ciu",
        "centro",
        "num_expuestos",
      ],
      options4: {
        headings: {
          clasificacion: "RIESGO",
          subclasificacion: "SUBCLASIFICACIÓN",
          descripcion: "DESCRIPCIÓN",
          depar: "DEPARTAMENTO",
          ciu: "MUNICIPIO",
          centro: "CENTRO DE TRABAJO",
          num_expuestos: "EXPUESTOS",
        },
        sortable: [
          "clasificacion",
          "subclasificacion",
          "depar",
          "ciu",
          "centro",
          "num_expuestos",
        ],
        texts: {
          filter: "",
          filterPlaceholder: "Buscar... ",
        },
      },

      // VARIABLES PARA LA TABLA ACEPTABLE
      array_lista_peligros5: [],
      columns5: [
        "clasificacion",
        "subclasificacion",
        "descripcion",
        "depar",
        "ciu",
        "centro",
        "num_expuestos",
      ],
      options5: {
        headings: {
          clasificacion: "RIESGO",
          subclasificacion: "SUBCLASIFICACIÓN",
          descripcion: "DESCRIPCIÓN",
          depar: "DEPARTAMENTO",
          ciu: "MUNICIPIO",
          centro: "CENTRO DE TRABAJO",
          num_expuestos: "EXPUESTOS",
        },
        sortable: [
          "clasificacion",
          "subclasificacion",
          "depar",
          "ciu",
          "centro",
          "num_expuestos",
        ],
        texts: {
          filter: "",
          filterPlaceholder: "Buscar... ",
        },
      },
      total_suma: 0,
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      array_noAceptable: [],
      array_AceptableCEspecifico: [],
      array_mejorable: [],
      array_aceptable: [],
    };
  },
  created() {
    if (!this.$store.state.email) {
      this.$router.push("/");
      return;
    }

    this.datos_sector();
    this.datos_regional();
    this.datos_departamento();
    this.datos_ciudades();
    this.datos_clientes();
  },
  methods: {
    tabla_matrices(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();

      this.lista_clientes = [];
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );

      db.collection("cliente_empresa") +
        func.onSnapshot((snapshot) => {
          let changes = snapshot.docChanges();
          changes.forEach((change) => {
            let estilo = "btn btn-block dropdown-toggle boton_12";
            if (change.doc.data().em_completo == true) {
              estilo += "btn btn-block dropdown-toggle btn_pendiente";
            }
            if (change.type === "added") {
              (async () => {
                let em_id_cliente_principal = change.doc.data()
                  .em_id_cliente_principal;
                let obtenerClientePrincipal = null;
                let nombre_cliente = null;
                if (em_id_cliente_principal && em_id_cliente_principal != "") {
                  obtenerClientePrincipal = await this.obtenerClientePrincipal(
                    em_id_cliente_principal
                  );
                }
                if (obtenerClientePrincipal) {
                  nombre_cliente = obtenerClientePrincipal.nombre_cliente;
                }
                this.lista_clientes.unshift({
                  id: `${change.doc.id}`,
                  sector: `${change.doc.data().em_sector}`,
                  empresa: nombre_cliente,
                  trabajo: `${change.doc.data().em_trabajo}`,
                  regional: `${change.doc.data().em_regional}`,
                  departamento: `${change.doc.data().em_departamento}`,
                  ciudad: `${change.doc.data().em_ciudad}`,
                  fecha: `${change.doc.data().em_fecha}`,
                  evaluacion_estado: `${change.doc.data().em_evaluacion}`,
                  em_baja: change.doc.data().em_baja,
                  completo: estilo,
                });
              })();
            }
          });
          NProgress.done();
          NProgress.remove();
        });
    },

    consulta_general_no_aceptable(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();
      this.lista_clientes = [];
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );

      func.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().em_baja == true) {
              let estilo = "btn btn-block dropdown-toggle boton_12";
              if (change.doc.data().em_completo == true) {
                estilo += "btn btn-block dropdown-toggle btn_pendiente";
              }
              this.lista_clientes.unshift({
                id: `${change.doc.id}`,
                sector: `${change.doc.data().em_sector}`,
                empresa: `${change.doc.data().em_empresa}`,
                trabajo: `${change.doc.data().em_trabajo}`,
                departamento: `${change.doc.data().em_departamento}`,
                ciudad: `${change.doc.data().em_ciudad}`,
                fecha: `${change.doc.data().em_fecha}`,
                evaluacion_estado: `${change.doc.data().em_evaluacion}`,
                mostrar: change.doc.data().em_baja,
                completo: estilo,
              });
            }
          }
          this.consulta_no_aceptable(
            `${change.doc.id}`,
            `${change.doc.data().em_trabajo}`,
            `${change.doc.data().em_departamento}`,
            `${change.doc.data().em_ciudad}`
          );
        });
      });
    },

    consulta_no_aceptable(id_empresa, trabajo, departamento, ciudad) {
      this.array_lista_peligros2 = [];
      db.collection("matriz_riesgo")
        .where("em_aceptabilidad", "==", "No Aceptable")
        .onSnapshot((snapshot) => {
          var changes = snapshot.docChanges();
          changes.forEach((change) => {
            if (`${change.doc.data().em_id_cliente}` == id_empresa) {
              if (change.type === "added") {
                (async () => {
                  let em_id_subclasificacion = change.doc.data()
                    .em_id_subclasificacion;
                  let obtenerSubclasificacion = null;
                  let subclasificacion = null;
                  if (em_id_subclasificacion && em_id_subclasificacion != "") {
                    obtenerSubclasificacion = await this.obtenerSubclasificacion(
                      em_id_subclasificacion
                    );
                  }
                  if (obtenerSubclasificacion) {
                    subclasificacion = obtenerSubclasificacion.subclasificacion;
                  }
                  this.array_lista_peligros2.unshift({
                    descripcion: `${change.doc.data().em_descripcion}`,
                    clasificacion: `${change.doc.data().em_clasificacion}`,
                    subclasificacion: subclasificacion,
                    tipo: `${change.doc.data().em_tipo}`,
                    rutinario: `${change.doc.data().em_rutinario}`,
                    subti: `${change.doc.data().em_subti}`,
                    otro_subti: `${change.doc.data().em_otro_subti}`,
                    aceptabilidad: `${change.doc.data().em_aceptabilidad}`,
                    num_expuestos: `${change.doc.data().em_num_expuestos}`,
                    depar: departamento,
                    ciu: ciudad,
                    centro: trabajo,
                  });
                })();
              }
            }
          });
          NProgress.done();
          NProgress.remove();
        });
    },

    consulta_general_aceptable_control(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();
      this.lista_clientes = [];
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );

      func.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().em_baja == true) {
              let estilo = "btn btn-block dropdown-toggle boton_12";
              if (change.doc.data().em_completo == true) {
                estilo += "btn btn-block dropdown-toggle btn_pendiente";
              }
              this.lista_clientes.unshift({
                id: `${change.doc.id}`,
                sector: `${change.doc.data().em_sector}`,
                empresa: `${change.doc.data().em_empresa}`,
                trabajo: `${change.doc.data().em_trabajo}`,
                departamento: `${change.doc.data().em_departamento}`,
                ciudad: `${change.doc.data().em_ciudad}`,
                fecha: `${change.doc.data().em_fecha}`,
                evaluacion_estado: `${change.doc.data().em_evaluacion}`,
                mostrar: change.doc.data().em_baja,
                completo: estilo,
              });
            }
          }
          this.consulta_aceptable_control(
            `${change.doc.id}`,
            `${change.doc.data().em_trabajo}`,
            `${change.doc.data().em_departamento}`,
            `${change.doc.data().em_ciudad}`
          );
        });
      });
    },

    consulta_aceptable_control(id_empresa, trabajo, departamento, ciudad) {
      this.array_lista_peligros3 = [];
      db.collection("matriz_riesgo")
        .where("em_aceptabilidad", "==", "Aceptable con Control Específico")
        .onSnapshot((snapshot) => {
          var changes = snapshot.docChanges();
          changes.forEach((change) => {
            if (`${change.doc.data().em_id_cliente}` == id_empresa) {
              if (change.type === "added") {
                (async () => {
                  let em_id_subclasificacion = change.doc.data()
                    .em_id_subclasificacion;
                  let obtenerSubclasificacion = null;
                  let subclasificacion = null;
                  if (em_id_subclasificacion && em_id_subclasificacion != "") {
                    obtenerSubclasificacion = await this.obtenerSubclasificacion(
                      em_id_subclasificacion
                    );
                  }
                  if (obtenerSubclasificacion) {
                    subclasificacion = obtenerSubclasificacion.subclasificacion;
                  }
                  this.array_lista_peligros3.unshift({
                    descripcion: `${change.doc.data().em_descripcion}`,
                    clasificacion: `${change.doc.data().em_clasificacion}`,
                    subclasificacion: subclasificacion,
                    tipo: `${change.doc.data().em_tipo}`,
                    rutinario: `${change.doc.data().em_rutinario}`,
                    subti: `${change.doc.data().em_subti}`,
                    otro_subti: `${change.doc.data().em_otro_subti}`,
                    aceptabilidad: `${change.doc.data().em_aceptabilidad}`,
                    num_expuestos: `${change.doc.data().em_num_expuestos}`,
                    depar: departamento,
                    ciu: ciudad,
                    centro: trabajo,
                  });
                })();
              }
            }
          });
          NProgress.done();
          NProgress.remove();
        });
    },

    consulta_general_mejorable(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();
      this.lista_clientes = [];
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );

      func.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().em_baja == true) {
              let estilo = "btn btn-block dropdown-toggle boton_12";
              if (change.doc.data().em_completo == true) {
                estilo += "btn btn-block dropdown-toggle btn_pendiente";
              }
              this.lista_clientes.unshift({
                id: `${change.doc.id}`,
                sector: `${change.doc.data().em_sector}`,
                empresa: `${change.doc.data().em_empresa}`,
                trabajo: `${change.doc.data().em_trabajo}`,
                departamento: `${change.doc.data().em_departamento}`,
                ciudad: `${change.doc.data().em_ciudad}`,
                fecha: `${change.doc.data().em_fecha}`,
                evaluacion_estado: `${change.doc.data().em_evaluacion}`,
                mostrar: change.doc.data().em_baja,
                completo: estilo,
              });
            }
          }
          this.consulta_mejorable(
            `${change.doc.id}`,
            `${change.doc.data().em_trabajo}`,
            `${change.doc.data().em_departamento}`,
            `${change.doc.data().em_ciudad}`
          );
        });
      });
    },

    consulta_mejorable(id_empresa, trabajo, departamento, ciudad) {
      this.array_lista_peligros4 = [];
      db.collection("matriz_riesgo")
        .where("em_aceptabilidad", "==", "Mejorable")
        .onSnapshot((snapshot) => {
          var changes = snapshot.docChanges();
          changes.forEach((change) => {
            if (`${change.doc.data().em_id_cliente}` == id_empresa) {
              if (change.type === "added") {
                (async () => {
                  let em_id_subclasificacion = change.doc.data()
                    .em_id_subclasificacion;
                  let obtenerSubclasificacion = null;
                  let subclasificacion = null;
                  if (em_id_subclasificacion && em_id_subclasificacion != "") {
                    obtenerSubclasificacion = await this.obtenerSubclasificacion(
                      em_id_subclasificacion
                    );
                  }
                  if (obtenerSubclasificacion) {
                    subclasificacion = obtenerSubclasificacion.subclasificacion;
                  }
                  this.array_lista_peligros4.unshift({
                    descripcion: `${change.doc.data().em_descripcion}`,
                    clasificacion: `${change.doc.data().em_clasificacion}`,
                    subclasificacion: subclasificacion,
                    tipo: `${change.doc.data().em_tipo}`,
                    rutinario: `${change.doc.data().em_rutinario}`,
                    subti: `${change.doc.data().em_subti}`,
                    otro_subti: `${change.doc.data().em_otro_subti}`,
                    aceptabilidad: `${change.doc.data().em_aceptabilidad}`,
                    num_expuestos: `${change.doc.data().em_num_expuestos}`,
                    depar: departamento,
                    ciu: ciudad,
                    centro: trabajo,
                  });
                })();
              }
            }
          });
          NProgress.done();
          NProgress.remove();
        });
    },

    consulta_general_aceptable(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();
      this.lista_clientes = [];
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );

      func.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().em_baja == true) {
              let estilo = "btn btn-block dropdown-toggle boton_12";
              if (change.doc.data().em_completo == true) {
                estilo += "btn btn-block dropdown-toggle btn_pendiente";
              }
              this.lista_clientes.unshift({
                id: `${change.doc.id}`,
                sector: `${change.doc.data().em_sector}`,
                empresa: `${change.doc.data().em_empresa}`,
                trabajo: `${change.doc.data().em_trabajo}`,
                departamento: `${change.doc.data().em_departamento}`,
                ciudad: `${change.doc.data().em_ciudad}`,
                fecha: `${change.doc.data().em_fecha}`,
                evaluacion_estado: `${change.doc.data().em_evaluacion}`,
                mostrar: change.doc.data().em_baja,
                completo: estilo,
              });
            }
          }
          this.consulta_aceptable(
            `${change.doc.id}`,
            `${change.doc.data().em_trabajo}`,
            `${change.doc.data().em_departamento}`,
            `${change.doc.data().em_ciudad}`
          );
        });
      });
    },

    consulta_aceptable(id_empresa, trabajo, departamento, ciudad) {
      this.array_lista_peligros5 = [];
      db.collection("matriz_riesgo")
        .where("em_aceptabilidad", "==", "Aceptable")
        .onSnapshot((snapshot) => {
          var changes = snapshot.docChanges();
          changes.forEach((change) => {
            if (`${change.doc.data().em_id_cliente}` == id_empresa) {
              if (change.type === "added") {
                (async () => {
                  let em_id_subclasificacion = change.doc.data()
                    .em_id_subclasificacion;
                  let obtenerSubclasificacion = null;
                  let subclasificacion = null;
                  if (em_id_subclasificacion && em_id_subclasificacion != "") {
                    obtenerSubclasificacion = await this.obtenerSubclasificacion(
                      em_id_subclasificacion
                    );
                  }
                  if (obtenerSubclasificacion) {
                    subclasificacion = obtenerSubclasificacion.subclasificacion;
                  }
                  this.array_lista_peligros5.unshift({
                    descripcion: `${change.doc.data().em_descripcion}`,
                    clasificacion: `${change.doc.data().em_clasificacion}`,
                    subclasificacion: subclasificacion,
                    tipo: `${change.doc.data().em_tipo}`,
                    rutinario: `${change.doc.data().em_rutinario}`,
                    subti: `${change.doc.data().em_subti}`,
                    otro_subti: `${change.doc.data().em_otro_subti}`,
                    aceptabilidad: `${change.doc.data().em_aceptabilidad}`,
                    num_expuestos: `${change.doc.data().em_num_expuestos}`,
                    depar: departamento,
                    ciu: ciudad,
                    centro: trabajo,
                  });
                })();
              }
            }
          });
          NProgress.done();
          NProgress.remove();
        });
    },

    async obtenerClientePrincipal(id) {
      let cliente = null;
      let obtenerClientePrincipal = await db
        .collection("cliente_principal")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            cliente = {
              nombre_cliente: `${doc.data().cl_cliente}`,
            };
            return cliente;
          } else {
            return cliente;
          }
        });
      return cliente;
    },

    async obtenerSubclasificacion(id) {
      let nameSubclasificacion = null;
      let obtenerClientePrincipal = await db
        .collection("nuevo_subclasificacion")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            nameSubclasificacion = {
              subclasificacion: `${doc.data().p_nuevo_subclasificacion}`,
            };
            return nameSubclasificacion;
          } else {
            return nameSubclasificacion;
          }
        });
      return nameSubclasificacion;
    },

    // CONSULTA SECTORES EXISTENTES
    datos_sector() {
      var sector_existente = "";
      var docRef = db
        .collection("cliente_principal")
        .orderBy("cl_sector", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_sector = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().cl_sector}` !== sector_existente) {
            this.mostrar_sector.push({
              key: doc.id,
              sector: `${doc.data().cl_sector}`,
            });
            sector_existente = `${doc.data().cl_sector}`;
          }
        });
      });
    },

    // CONSULTA REGIONALES
    datos_regional() {
      var regional_existente = "";
      var docRef = db
        .collection("cliente_empresa")
        .where("em_baja", "==", true)
        .orderBy("em_regional", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_regional = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().em_regional}` !== regional_existente) {
            this.mostrar_regional.push({
              key: doc.id,
              regional: `${doc.data().em_regional}`,
            });
            regional_existente = `${doc.data().em_regional}`;
          }
        });
      });
    },

    // CONSULTA DEPARTAMENTO
    datos_departamento() {
      var departamento_existente = "";
      var docRef = db
        .collection("cliente_empresa")
        .where("em_baja", "==", true)
        .orderBy("em_departamento", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_departamento = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().em_departamento}` !== departamento_existente) {
            this.mostrar_departamento.push({
              key: doc.id,
              departamento: `${doc.data().em_departamento}`,
            });
            departamento_existente = `${doc.data().em_departamento}`;
          }
          this.mostrar_departamento = [...new Set(this.mostrar_departamento)];
        });
        this.mostrar_departamento = [...new Set(this.mostrar_departamento)];
      });
    },

    // CONSULTA DEPARTAMENTO
    datos_departamento_filtro(event) {
      this.nuevo_valor = event.target.value;
      if (this.nuevo_valor != "") {
        var departamento_existente = "";
        var docRef = db
          .collection("cliente_empresa")
          .where("em_baja", "==", true)
          .where("em_regional", "==", this.nuevo_valor)
          .orderBy("em_departamento", "asc");
        docRef.onSnapshot((querySnapshot) => {
          this.mostrar_departamento = [];
          querySnapshot.forEach((doc) => {
            if (`${doc.data().em_departamento}` !== departamento_existente) {
              this.mostrar_departamento.push({
                key: doc.id,
                departamentos: `${doc.data().em_departamento}`,
              });
              departamento_existente = `${doc.data().em_departamento}`;
            }
            this.mostrar_departamento = [...new Set(this.mostrar_departamento)];
          });
          this.mostrar_departamento = [...new Set(this.mostrar_departamento)];
        });
      } else {
        this.datos_departamento();
      }
    },

    // CONSULTA CIUDADES
    datos_ciudades() {
      var ciudades_existente = "";
      var docRef = db
        .collection("cliente_empresa")
        .where("em_baja", "==", true)
        .orderBy("em_ciudad", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_ciudades = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().em_ciudad}` !== ciudades_existente) {
            this.mostrar_ciudades.push({
              key: doc.id,
              ciudad: `${doc.data().em_ciudad}`,
            });
            ciudades_existente = `${doc.data().em_ciudad}`;
          }
        });
      });
    },

    // CONSULTA CIUDADES
    datos_ciudades_filtro(event) {
      this.nuevo_valor_departamento = event.target.value;
      if (this.nuevo_valor_departamento != "") {
        var ciudades_existente = "";
        var docRef = db
          .collection("cliente_empresa")
          .where("em_baja", "==", true)
          .where("em_regional", "==", this.nuevo_valor)
          .where("em_departamento", "==", this.nuevo_valor_departamento)
          .orderBy("em_ciudad", "asc");
        docRef.onSnapshot((querySnapshot) => {
          this.mostrar_ciudades = [];
          querySnapshot.forEach((doc) => {
            if (`${doc.data().em_ciudad}` !== ciudades_existente) {
              this.mostrar_ciudades.push({
                key: doc.id,
                ciudad: `${doc.data().em_ciudad}`,
              });
              ciudades_existente = `${doc.data().em_ciudad}`;
            }
          });
        });
      } else {
        this.datos_ciudades();
      }
    },

    // CONSULTA CLIENTES
    datos_clientes() {
      var clientes_existente = "";
      var docRef = db
        .collection("cliente_principal")
        .orderBy("cl_cliente", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_clientes = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().cl_cliente}` != clientes_existente) {
            this.mostrar_clientes.push({
              key: doc.id,
              cliente: `${doc.data().cl_cliente}`,
            });
            clientes_existente = `${doc.data().cl_cliente}`;
          }
        });
      });
    },

    grafica_matrices(
      sector_existente,
      regional_existente,
      departamento_existente,
      ciudades_existente,
      clientes_existente
    ) {
      NProgress.start();
      var filtro_consulta = "";
      var filtro_consulta1 = "";
      var filtro_consulta2 = "";
      var filtro_consulta3 = "";
      var filtro_consulta4 = "";
      if (sector_existente != "") {
        filtro_consulta = ".where('em_sector', '==', sector_existente)";
      }
      if (regional_existente != "") {
        filtro_consulta1 = ".where('em_regional', '==', regional_existente)";
      }
      if (departamento_existente != "") {
        filtro_consulta2 =
          ".where('em_departamento', '==', departamento_existente)";
      }
      if (ciudades_existente != "") {
        filtro_consulta3 = ".where('em_ciudad', '==', ciudades_existente)";
      }
      if (clientes_existente != "") {
        filtro_consulta4 =
          ".where('em_id_cliente_principal', '==', clientes_existente)";
      }
      var docRef = "db.collection('cliente_empresa')";
      var func = eval(
        docRef +
          filtro_consulta +
          filtro_consulta1 +
          filtro_consulta2 +
          filtro_consulta3 +
          filtro_consulta4
      );
      func.onSnapshot((snapshot) => {
        let changes = snapshot.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().em_baja == true) {
              this.lista_clientes.unshift({
                id: `${change.doc.id}`,
              });
              this.grafica_matrices1(`${change.doc.id}`);
            }
          }
        });
      });
    },

    async grafica_matrices1(id_empresa) {
      this.array_noAceptable = [];
      this.array_AceptableCEspecifico = [];
      this.array_mejorable = [];
      this.array_aceptable = [];
      let totalNuevo = await db
        .collection("matriz_riesgo")
        .where("em_id_cliente", "==", id_empresa)
        .get()
        .then((querySnapshot) => {
          let arrayGrafica = [];
          querySnapshot.forEach((doc) => {
            if (doc.data().em_aceptabilidad == "No Aceptable") {
              this.array_noAceptable.unshift(`${doc.data().em_clasificacion}`);
            }
            if (
              doc.data().em_aceptabilidad == "Aceptable con Control Específico"
            ) {
              this.array_AceptableCEspecifico.unshift(
                `${doc.data().em_clasificacion}`
              );
            }
            if (doc.data().em_aceptabilidad == "Mejorable") {
              this.array_mejorable.unshift(`${doc.data().em_clasificacion}`);
            }
            if (doc.data().em_aceptabilidad == "Aceptable") {
              this.array_aceptable.unshift(`${doc.data().em_clasificacion}`);
            }
            console.log(this.array_noAceptable.length);
            arrayGrafica = {
              num1: this.array_noAceptable.length,
              num2: this.array_AceptableCEspecifico.length,
              num3: this.array_mejorable.length,
              num4: this.array_aceptable.length,
              total_suma:
                this.array_noAceptable.length +
                this.array_AceptableCEspecifico.length +
                this.array_mejorable.length +
                this.array_aceptable.length,
            };
          });
          return arrayGrafica;
        })
        .catch((error) => {
          console.log(error);
          return null;
        });
      if (totalNuevo) {
        document.getElementById("total_peligros").innerHTML =
          totalNuevo.total_suma;
        var idGrafica = document.getElementById("peligros_grafica_matriz");
        idGrafica.innerHTML = "";
        idGrafica.innerHTML =
          '<canvas id="grafica_peligros" style="background-color: transparent; width: 1vh; height: 1vh;"></canvas>';
        var ctx = document.getElementById("grafica_peligros");
        var grafica_peligros = new Chart(ctx, {
          type: "bar",
          data: {
            labels: [
              "No Aceptable",
              "Aceptable con Control Específico",
              "Mejorable",
              "Aceptable",
            ],
            datasets: [
              {
                data: [
                  totalNuevo.num1,
                  totalNuevo.num2,
                  totalNuevo.num3,
                  totalNuevo.num4,
                ],
                backgroundColor: [
                  "rgba(231, 45, 64, 0.6)",
                  "rgba( 241, 227, 0 , 0.6)",
                  "rgba(66, 171, 53, 0.6)",
                  "rgba(26, 194, 253, 0.6)",
                ],
                borderColor: [
                  "rgba(231, 45, 64, 0.6)",
                  "rgba( 241, 227, 0 , 1)",
                  "rgba(66, 171, 53, 1)",
                  "rgba(26, 194, 253, 1)",
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
            legend: {
              display: false,
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    fontSize: 14,
                    fontStyle: "bold",
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    fontSize: 14,
                  },
                },
              ],
            },
          },
        });
        NProgress.done();
        NProgress.remove();
      }
    },

    loader(total_peligros) {
      this.total_peligros_vue = total_peligros;
    },

    // OPCIÓN EDITAR EN LA TABLA
    async editar(id) {
      this.$store.state.msp_c_key = id;
      this.$store.state.msp_lista_procesos = [];
      this.cargar_procesos = true;
      await this.excel_proceso_consulta(id);
      this.$store.state.estado_navbar_matriz_peligro =
        "registro_centro_trabajo";
      this.$router.push("/matriz-peligro");
    },

    // FUNCIÓN PARA MOSTRAR PROCESO
    excel_proceso_consulta(id_cliente) {
      // FUNCIÓN PARA IMPRIMIR DATOS DE LA BASE DE DATOS EN LA MATRIZ
      db.collection("proceso")
        .where("em_id_cliente", "==", id_cliente)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.excel_zona_consulta(doc.id, doc.data().em_proceso_riesgo);
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR ZONA
    excel_zona_consulta(id_proceso, proceso_riesgo) {
      db.collection("zona")
        .where("em_id_proceso", "==", id_proceso)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.excel_acti_consulta(
              id_proceso,
              proceso_riesgo,
              doc.id,
              doc.data().em_zona
            );
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR TABLA ACTIVIDADES
    excel_acti_consulta(id_proceso, proceso_riesgo, id_zona, zona) {
      db.collection("actividades")
        .where("em_id_zona", "==", id_zona)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.excel_tareas_consultar(
              id_proceso,
              proceso_riesgo,
              id_zona,
              zona,
              doc.id,
              doc.data().em_actividades
            );
          });
        });
    },

    // FUNCIÓN PARA MOSTRAR TABLA TAREAS
    excel_tareas_consultar(
      id_proceso,
      proceso_riesgo,
      id_zona,
      zona,
      id_acti,
      actividades
    ) {
      db.collection("tareas")
        .where("em_id_acti", "==", id_acti)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (this.cargar_procesos) {
              this.$store.state.msp_lista_procesos.unshift({
                id: this.$store.state.msp_c_key,
                proceso_riesgo: proceso_riesgo,
                id_proceso: id_proceso,
                zona: zona,
                id_zona: id_zona,
                actividad: actividades,
                id_acti: id_acti,
                tarea: doc.data().em_tareas,
                id_tareas: doc.id,
                id_matriz: [],
              });
              let set = new Set(
                this.$store.state.msp_lista_procesos.map(JSON.stringify)
              );
              this.$store.state.msp_lista_procesos = Array.from(set).map(
                JSON.parse
              );
              this.obtener_rutinario(
                doc.id,
                proceso_riesgo,
                zona,
                actividades,
                doc.data().em_tareas
              );

              this.$store.state.msp_procesos_iper.forEach((i) => {
                if (i.p_nuevo_proceso == proceso_riesgo) {
                } else {
                  this.$store.state.msp_procesos_iper.push({
                    p_nuevo_proceso: proceso_riesgo,
                  });
                  let set = new Set(
                    this.$store.state.msp_procesos_iper.map(JSON.stringify)
                  );
                  this.$store.state.msp_procesos_iper = Array.from(set).map(
                    JSON.parse
                  );
                }
              });

              this.$store.state.msp_zonas_iper.forEach((i) => {
                if (i.p_nuevo_zona == zona) {
                } else {
                  this.$store.state.msp_zonas_iper.push({
                    p_nuevo_zona: zona,
                  });
                  let set = new Set(
                    this.$store.state.msp_zonas_iper.map(JSON.stringify)
                  );
                  this.$store.state.msp_zonas_iper = Array.from(set).map(
                    JSON.parse
                  );
                }
              });
              this.$store.state.msp_actividades_iper.forEach((i) => {
                if (i.p_nuevo_actividad == actividades) {
                } else {
                  this.$store.state.msp_actividades_iper.push({
                    p_nuevo_actividad: actividades,
                  });
                  let set = new Set(
                    this.$store.state.msp_actividades_iper.map(JSON.stringify)
                  );
                  this.$store.state.msp_actividades_iper = Array.from(set).map(
                    JSON.parse
                  );
                }
              });
              this.$store.state.msp_tareas_iper.forEach((i) => {
                if (i.p_nuevo_tareas == doc.data().em_tareas) {
                } else {
                  this.$store.state.msp_tareas_iper.push({
                    p_nuevo_tareas: doc.data().em_tareas,
                  });
                  let set = new Set(
                    this.$store.state.msp_tareas_iper.map(JSON.stringify)
                  );
                  this.$store.state.msp_tareas_iper = Array.from(set).map(
                    JSON.parse
                  );
                }
              });
            } else {
              this.excel_matriz_consultar(
                id_proceso,
                proceso_riesgo,
                id_zona,
                zona,
                id_acti,
                actividades,
                doc.id,
                doc.data().em_tareas
              );
            }
          });
        });
    },

    async obtener_rutinario(
      id_tareas,
      proceso_riesgo,
      zona,
      actividades,
      tareas
    ) {
      await db
        .collection("matriz_riesgo")
        .where("em_id_tareas", "==", id_tareas)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            for (
              let element = 0;
              element < this.$store.state.msp_lista_procesos.length;
              element++
            ) {
              if (
                this.$store.state.msp_lista_procesos[element].id_tareas ==
                id_tareas
              ) {
                this.$store.state.msp_lista_procesos[element].id_matriz.push(
                  doc.id
                );
                this.$store.state.msp_lista_procesos[
                  element
                ].rutinario_peligro = doc.data().em_rutinario;
              }
            }
            let efectos = [
              doc.data().em_efecto1,
              doc.data().em_efecto2,
              doc.data().em_efecto3,
              doc.data().em_efecto4,
              doc.data().em_efecto5,
              doc.data().em_efecto6,
              doc.data().em_efecto7,
              doc.data().em_efecto8,
              doc.data().em_efecto9,
              doc.data().em_efecto10,
              doc.data().em_efecto11,
              doc.data().em_efecto12,
              doc.data().em_efecto13,
              doc.data().em_efecto14,
              doc.data().em_efecto15,
              doc.data().em_efecto16,
              doc.data().em_efecto17,
              doc.data().em_efecto18,
              doc.data().em_efecto19,
              doc.data().em_efecto20,
              doc.data().em_efecto21,
              doc.data().em_efecto22,
              doc.data().em_otro_efecto1,
              doc.data().em_otro_efecto2,
            ];

            let control_fuente = [
              doc.data().em_cf1,
              doc.data().em_cf2,
              doc.data().em_cf3,
              doc.data().em_control_fuente,
              doc.data().em_control_fuente1,
              doc.data().em_control_fuente2,
              doc.data().em_control_fuente3,
              doc.data().em_control_fuente4,
              doc.data().em_control_fuente5,
              doc.data().em_control_fuente6,
              doc.data().em_control_fuente7,
              doc.data().em_control_fuente8,
              doc.data().em_control_fuente9,
              doc.data().em_control_fuente10,
              doc.data().em_control_fuente11,
              doc.data().em_control_fuente12,
              doc.data().em_control_fuente13,
              doc.data().em_control_fuente14,
              doc.data().em_control_fuente15,
              doc.data().em_control_fuente16,
              doc.data().em_control_fuente17,
              doc.data().em_control_fuente18,
              doc.data().em_control_fuente19,
              doc.data().em_control_fuente20,
              doc.data().em_control_fuente21,
              doc.data().em_control_fuente22,
              doc.data().em_control_fuente23,
              doc.data().em_control_fuente24,
              doc.data().em_control_fuente25,
              doc.data().em_control_fuente26,
              doc.data().em_control_fuente27,
              doc.data().em_control_fuente28,
              doc.data().em_control_fuente29,
              doc.data().em_control_fuente30,
              doc.data().em_control_fuente31,
              doc.data().em_control_fuente32,
              doc.data().em_control_fuente33,
              doc.data().em_control_fuente34,
            ];
            let control_medio = [
              doc.data().em_cm1,
              doc.data().em_cm2,
              doc.data().em_cm3,
              doc.data().em_cm4,
              doc.data().em_cm5,
              doc.data().em_cm6,
              doc.data().em_cm7,
              doc.data().em_cm8,
              doc.data().em_cm9,
              doc.data().em_cm10,
              doc.data().em_cm11,
              doc.data().em_control_medio,
              doc.data().em_control_medio1,
              doc.data().em_control_medio2,
              doc.data().em_control_medio3,
              doc.data().em_control_medio4,
              doc.data().em_control_medio5,
              doc.data().em_control_medio6,
              doc.data().em_control_medio7,
              doc.data().em_control_medio8,
              doc.data().em_control_medio9,
              doc.data().em_control_medio10,
              doc.data().em_control_medio11,
              doc.data().em_control_medio12,
              doc.data().em_control_medio13,
              doc.data().em_control_medio14,
              doc.data().em_control_medio15,
              doc.data().em_control_medio16,
              doc.data().em_control_medio17,
              doc.data().em_control_medio18,
              doc.data().em_control_medio19,
              doc.data().em_control_medio20,
              doc.data().em_control_medio21,
              doc.data().em_control_medio22,
              doc.data().em_control_medio23,
              doc.data().em_control_medio24,
              doc.data().em_control_medio25,
              doc.data().em_control_medio26,
              doc.data().em_control_medio27,
              doc.data().em_control_medio28,
              doc.data().em_control_medio29,
              doc.data().em_control_medio30,
              doc.data().em_control_medio31,
              doc.data().em_control_medio32,
              doc.data().em_control_medio33,
              doc.data().em_control_medio34,
            ];
            let control_individuo = [
              doc.data().em_ci1,
              doc.data().em_ci2,
              doc.data().em_ci3,
              doc.data().em_ci4,
              doc.data().em_control_individuo,
              doc.data().em_control_individuo1,
              doc.data().em_control_individuo2,
              doc.data().em_control_individuo3,
              doc.data().em_control_individuo4,
              doc.data().em_control_individuo5,
              doc.data().em_control_individuo6,
              doc.data().em_control_individuo7,
              doc.data().em_control_individuo8,
              doc.data().em_control_individuo9,
              doc.data().em_control_individuo10,
              doc.data().em_control_individuo11,
              doc.data().em_control_individuo12,
              doc.data().em_control_individuo13,
              doc.data().em_control_individuo14,
              doc.data().em_control_individuo15,
              doc.data().em_control_individuo16,
              doc.data().em_control_individuo17,
              doc.data().em_control_individuo18,
              doc.data().em_control_individuo19,
              doc.data().em_control_individuo20,
              doc.data().em_control_individuo21,
              doc.data().em_control_individuo22,
              doc.data().em_control_individuo23,
              doc.data().em_control_individuo24,
              doc.data().em_control_individuo25,
              doc.data().em_control_individuo26,
              doc.data().em_control_individuo27,
              doc.data().em_control_individuo28,
              doc.data().em_control_individuo29,
              doc.data().em_control_individuo30,
              doc.data().em_control_individuo31,
              doc.data().em_control_individuo32,
              doc.data().em_control_individuo33,
              doc.data().em_control_individuo34,
            ];

            let id_peligro = doc.data().em_id_peligro;
            let id_subcla = doc.data().em_id_subclasificacion;
            let id_efectos_posibles = doc.data().em_id_efectos_posibles;

            for (let i = 0; i < control_fuente.length; i++) {
              control_fuente[i] = `${control_fuente[i]}`;
              if (control_fuente[i] === "undefined" || !control_fuente[i]) {
                control_fuente.splice(i, 1);
              }
            }
            control_fuente = control_fuente.map((item) => {
              if (item === undefined || item === "undefined") {
              } else return item;
            });
            control_fuente = control_fuente.filter((dato) => {
              if (
                dato !== "" ||
                dato !== "undefined" ||
                dato !== undefined ||
                dato !== false ||
                dato !== NaN ||
                dato !== null
              ) {
                return dato;
              }
            });

            for (let i = 0; i < control_medio.length; i++) {
              control_medio[i] = `${control_medio[i]}`;
              if (control_medio[i] === "undefined" || !control_medio[i]) {
                control_medio.splice(i, 1);
              }
            }
            control_medio = control_medio.map((item) => {
              if (item === undefined || item === "undefined") {
              } else return item;
            });
            control_medio = control_medio.filter((dato) => {
              if (
                dato !== "" ||
                dato !== "undefined" ||
                dato !== undefined ||
                dato !== false ||
                dato !== NaN ||
                dato !== null
              ) {
                return dato;
              }
            });

            for (let i = 0; i < control_individuo.length; i++) {
              control_individuo[i] = `${control_individuo[i]}`;
              if (
                control_individuo[i] === "undefined" ||
                !control_individuo[i]
              ) {
                control_individuo.splice(i, 1);
              }
            }
            control_individuo = control_individuo.map((item) => {
              if (item === undefined || item === "undefined") {
              } else return item;
            });
            control_individuo = control_individuo.filter((dato) => {
              if (
                dato !== "" ||
                dato !== "undefined" ||
                dato !== undefined ||
                dato !== false ||
                dato !== NaN ||
                dato !== null
              ) {
                return dato;
              }
            });

            if (id_peligro === "undefined" || !id_peligro) id_peligro = "";

            if (id_subcla === "undefined" || !id_subcla) id_subcla = "";

            if (id_efectos_posibles === "undefined" || !id_efectos_posibles)
              id_efectos_posibles = "";

            efectos = efectos.filter(Boolean);

            let styles = this.estilos_evaluacion_riesgo_obj(
              doc.data().em_nivel_eficiencia,
              doc.data().em_nivel_exposicion,
              doc.data().em_nivel_probabilidad,
              doc.data().em_nivel_consecuencia
            );

            let class_btn_outline = styles.class_btn_outline;
            let class_btn_alerts = styles.class_btn_alerts;

            // OBTENER LOS DATOS
            db.collection("matriz_riesgo")
              .doc(doc.id)
              .update({
                em_id_cliente: this.$store.state.msp_c_key,

                em_proceso: proceso_riesgo,
                em_zona: zona,
                em_actividad: actividades,
                em_tarea: tareas,

                em_id_peligro: id_peligro,
                em_id_subclasificacion: id_subcla,
                em_id_efectos_posibles: id_efectos_posibles,

                em_efecto_posible: Array.from(efectos),
                em_c_fuente: Array.from(control_fuente),
                em_c_medio: Array.from(control_medio),
                em_c_individuo: Array.from(control_individuo),
                em_antecedente: "",

                em_class_btn_outline: class_btn_outline,
                em_class_btn_alerts: class_btn_alerts,

                em_subti: firebase.firestore.FieldValue.delete(),
                em_otro_subti: firebase.firestore.FieldValue.delete(),

                em_efecto1: firebase.firestore.FieldValue.delete(),
                em_efecto2: firebase.firestore.FieldValue.delete(),
                em_efecto3: firebase.firestore.FieldValue.delete(),
                em_efecto4: firebase.firestore.FieldValue.delete(),
                em_efecto5: firebase.firestore.FieldValue.delete(),
                em_efecto6: firebase.firestore.FieldValue.delete(),
                em_efecto7: firebase.firestore.FieldValue.delete(),
                em_efecto8: firebase.firestore.FieldValue.delete(),
                em_efecto9: firebase.firestore.FieldValue.delete(),
                em_efecto10: firebase.firestore.FieldValue.delete(),
                em_efecto11: firebase.firestore.FieldValue.delete(),
                em_efecto12: firebase.firestore.FieldValue.delete(),
                em_efecto13: firebase.firestore.FieldValue.delete(),
                em_efecto14: firebase.firestore.FieldValue.delete(),
                em_efecto15: firebase.firestore.FieldValue.delete(),
                em_efecto16: firebase.firestore.FieldValue.delete(),
                em_efecto17: firebase.firestore.FieldValue.delete(),
                em_efecto18: firebase.firestore.FieldValue.delete(),
                em_efecto19: firebase.firestore.FieldValue.delete(),
                em_efecto20: firebase.firestore.FieldValue.delete(),
                em_efecto21: firebase.firestore.FieldValue.delete(),
                em_efecto22: firebase.firestore.FieldValue.delete(),
                em_otro_efecto1: firebase.firestore.FieldValue.delete(),
                em_otro_efecto2: firebase.firestore.FieldValue.delete(),

                em_cf1: firebase.firestore.FieldValue.delete(),
                em_cf2: firebase.firestore.FieldValue.delete(),
                em_cf3: firebase.firestore.FieldValue.delete(),
                em_control_fuente: firebase.firestore.FieldValue.delete(),
                em_control_fuente1: firebase.firestore.FieldValue.delete(),
                em_control_fuente2: firebase.firestore.FieldValue.delete(),
                em_control_fuente3: firebase.firestore.FieldValue.delete(),
                em_control_fuente4: firebase.firestore.FieldValue.delete(),
                em_control_fuente5: firebase.firestore.FieldValue.delete(),
                em_control_fuente6: firebase.firestore.FieldValue.delete(),
                em_control_fuente7: firebase.firestore.FieldValue.delete(),
                em_control_fuente8: firebase.firestore.FieldValue.delete(),
                em_control_fuente9: firebase.firestore.FieldValue.delete(),
                em_control_fuente10: firebase.firestore.FieldValue.delete(),
                em_control_fuente11: firebase.firestore.FieldValue.delete(),
                em_control_fuente12: firebase.firestore.FieldValue.delete(),
                em_control_fuente13: firebase.firestore.FieldValue.delete(),
                em_control_fuente14: firebase.firestore.FieldValue.delete(),
                em_control_fuente15: firebase.firestore.FieldValue.delete(),
                em_control_fuente16: firebase.firestore.FieldValue.delete(),
                em_control_fuente17: firebase.firestore.FieldValue.delete(),
                em_control_fuente18: firebase.firestore.FieldValue.delete(),
                em_control_fuente19: firebase.firestore.FieldValue.delete(),
                em_control_fuente20: firebase.firestore.FieldValue.delete(),
                em_control_fuente21: firebase.firestore.FieldValue.delete(),
                em_control_fuente22: firebase.firestore.FieldValue.delete(),
                em_control_fuente23: firebase.firestore.FieldValue.delete(),
                em_control_fuente24: firebase.firestore.FieldValue.delete(),
                em_control_fuente25: firebase.firestore.FieldValue.delete(),
                em_control_fuente26: firebase.firestore.FieldValue.delete(),
                em_control_fuente27: firebase.firestore.FieldValue.delete(),
                em_control_fuente28: firebase.firestore.FieldValue.delete(),
                em_control_fuente29: firebase.firestore.FieldValue.delete(),
                em_control_fuente30: firebase.firestore.FieldValue.delete(),
                em_control_fuente31: firebase.firestore.FieldValue.delete(),
                em_control_fuente32: firebase.firestore.FieldValue.delete(),
                em_control_fuente33: firebase.firestore.FieldValue.delete(),
                em_control_fuente34: firebase.firestore.FieldValue.delete(),

                em_cm1: firebase.firestore.FieldValue.delete(),
                em_cm2: firebase.firestore.FieldValue.delete(),
                em_cm3: firebase.firestore.FieldValue.delete(),
                em_cm4: firebase.firestore.FieldValue.delete(),
                em_cm5: firebase.firestore.FieldValue.delete(),
                em_cm6: firebase.firestore.FieldValue.delete(),
                em_cm7: firebase.firestore.FieldValue.delete(),
                em_cm8: firebase.firestore.FieldValue.delete(),
                em_cm9: firebase.firestore.FieldValue.delete(),
                em_cm10: firebase.firestore.FieldValue.delete(),
                em_cm11: firebase.firestore.FieldValue.delete(),
                em_control_medio: firebase.firestore.FieldValue.delete(),
                em_control_medio1: firebase.firestore.FieldValue.delete(),
                em_control_medio2: firebase.firestore.FieldValue.delete(),
                em_control_medio3: firebase.firestore.FieldValue.delete(),
                em_control_medio4: firebase.firestore.FieldValue.delete(),
                em_control_medio5: firebase.firestore.FieldValue.delete(),
                em_control_medio6: firebase.firestore.FieldValue.delete(),
                em_control_medio7: firebase.firestore.FieldValue.delete(),
                em_control_medio8: firebase.firestore.FieldValue.delete(),
                em_control_medio9: firebase.firestore.FieldValue.delete(),
                em_control_medio10: firebase.firestore.FieldValue.delete(),
                em_control_medio11: firebase.firestore.FieldValue.delete(),
                em_control_medio12: firebase.firestore.FieldValue.delete(),
                em_control_medio13: firebase.firestore.FieldValue.delete(),
                em_control_medio14: firebase.firestore.FieldValue.delete(),
                em_control_medio15: firebase.firestore.FieldValue.delete(),
                em_control_medio16: firebase.firestore.FieldValue.delete(),
                em_control_medio17: firebase.firestore.FieldValue.delete(),
                em_control_medio18: firebase.firestore.FieldValue.delete(),
                em_control_medio19: firebase.firestore.FieldValue.delete(),
                em_control_medio20: firebase.firestore.FieldValue.delete(),
                em_control_medio21: firebase.firestore.FieldValue.delete(),
                em_control_medio22: firebase.firestore.FieldValue.delete(),
                em_control_medio23: firebase.firestore.FieldValue.delete(),
                em_control_medio24: firebase.firestore.FieldValue.delete(),
                em_control_medio25: firebase.firestore.FieldValue.delete(),
                em_control_medio26: firebase.firestore.FieldValue.delete(),
                em_control_medio27: firebase.firestore.FieldValue.delete(),
                em_control_medio28: firebase.firestore.FieldValue.delete(),
                em_control_medio29: firebase.firestore.FieldValue.delete(),
                em_control_medio30: firebase.firestore.FieldValue.delete(),
                em_control_medio31: firebase.firestore.FieldValue.delete(),
                em_control_medio32: firebase.firestore.FieldValue.delete(),
                em_control_medio33: firebase.firestore.FieldValue.delete(),
                em_control_medio34: firebase.firestore.FieldValue.delete(),

                em_ci1: firebase.firestore.FieldValue.delete(),
                em_ci2: firebase.firestore.FieldValue.delete(),
                em_ci3: firebase.firestore.FieldValue.delete(),
                em_ci4: firebase.firestore.FieldValue.delete(),
                em_control_individuo: firebase.firestore.FieldValue.delete(),
                em_control_individuo1: firebase.firestore.FieldValue.delete(),
                em_control_individuo2: firebase.firestore.FieldValue.delete(),
                em_control_individuo3: firebase.firestore.FieldValue.delete(),
                em_control_individuo4: firebase.firestore.FieldValue.delete(),
                em_control_individuo5: firebase.firestore.FieldValue.delete(),
                em_control_individuo6: firebase.firestore.FieldValue.delete(),
                em_control_individuo7: firebase.firestore.FieldValue.delete(),
                em_control_individuo8: firebase.firestore.FieldValue.delete(),
                em_control_individuo9: firebase.firestore.FieldValue.delete(),
                em_control_individuo10: firebase.firestore.FieldValue.delete(),
                em_control_individuo11: firebase.firestore.FieldValue.delete(),
                em_control_individuo12: firebase.firestore.FieldValue.delete(),
                em_control_individuo13: firebase.firestore.FieldValue.delete(),
                em_control_individuo14: firebase.firestore.FieldValue.delete(),
                em_control_individuo15: firebase.firestore.FieldValue.delete(),
                em_control_individuo16: firebase.firestore.FieldValue.delete(),
                em_control_individuo17: firebase.firestore.FieldValue.delete(),
                em_control_individuo18: firebase.firestore.FieldValue.delete(),
                em_control_individuo19: firebase.firestore.FieldValue.delete(),
                em_control_individuo20: firebase.firestore.FieldValue.delete(),
                em_control_individuo21: firebase.firestore.FieldValue.delete(),
                em_control_individuo22: firebase.firestore.FieldValue.delete(),
                em_control_individuo23: firebase.firestore.FieldValue.delete(),
                em_control_individuo24: firebase.firestore.FieldValue.delete(),
                em_control_individuo25: firebase.firestore.FieldValue.delete(),
                em_control_individuo26: firebase.firestore.FieldValue.delete(),
                em_control_individuo27: firebase.firestore.FieldValue.delete(),
                em_control_individuo28: firebase.firestore.FieldValue.delete(),
                em_control_individuo29: firebase.firestore.FieldValue.delete(),
                em_control_individuo30: firebase.firestore.FieldValue.delete(),
                em_control_individuo31: firebase.firestore.FieldValue.delete(),
                em_control_individuo32: firebase.firestore.FieldValue.delete(),
                em_control_individuo33: firebase.firestore.FieldValue.delete(),
                em_control_individuo34: firebase.firestore.FieldValue.delete(),
              })
              .then(() => {})
              .catch((error) => {
                // EL DOCUMENTO PROBABLEMENTE NO EXISTE.
                console.error("Error al actualizar la información: ", error);
              });
          });
        });
    },

    estilos_evaluacion_riesgo_obj(
      nivel_eficiencia,
      nivel_exposicion,
      nivel_probabilidad,
      nivel_consecuencia
    ) {
      let interpretacion = "";
      let class_btn_outline = "";
      let nivel_riesgo = "";
      let interpretacion_nr = "";
      let aceptabilidad = "";
      let class_btn_alerts = "";

      if (nivel_eficiencia == "") {
        nivel_eficiencia = 0;
        nivel_exposicion = 0;
        nivel_probabilidad = 0;
        nivel_consecuencia = 0;
      }
      if (nivel_probabilidad >= 24) {
        interpretacion = "Muy alto";
        class_btn_outline = "btn btn-outline-danger";
      }
      if (nivel_probabilidad >= 10 && nivel_probabilidad <= 20) {
        interpretacion = "Alto";
        class_btn_outline = "btn btn-outline-warning";
      }
      if (nivel_probabilidad >= 6 && nivel_probabilidad <= 8) {
        interpretacion = "Medio";
        class_btn_outline = "btn btn-outline-primary";
      }
      if (nivel_probabilidad >= 0 && nivel_probabilidad <= 4) {
        interpretacion = "Bajo";
        class_btn_outline = "btn btn-outline-success";
      }

      if (nivel_consecuencia == "0" || nivel_probabilidad == 0) {
        nivel_riesgo = 20;
      } else {
        nivel_riesgo = nivel_probabilidad * nivel_consecuencia;
      }

      if (nivel_riesgo >= 600 && nivel_riesgo <= 4000) {
        interpretacion_nr = "l";
        aceptabilidad = "No Aceptable";

        class_btn_alerts = "btn btn-danger btn-block";
      } else if (nivel_riesgo >= 150 && nivel_riesgo <= 500) {
        interpretacion_nr = "ll";
        aceptabilidad = "Aceptable con Control Específico";

        class_btn_alerts = "btn btn-warning btn-block";
      } else if (nivel_riesgo >= 40 && nivel_riesgo <= 120) {
        interpretacion_nr = "lll";
        aceptabilidad = "Mejorable";

        class_btn_alerts = "btn btn-primary btn-block";
      } else if (nivel_riesgo == 0 || nivel_riesgo == 20) {
        interpretacion_nr = "lV";
        aceptabilidad = "Aceptable";

        class_btn_alerts = "btn btn-success btn-block";
      }

      let clases = {
        class_btn_alerts,
        class_btn_outline,
      };
      return clases;
    },

    // FUNCIÓN PARA MOSTRAR TABLA MATRIZ
    excel_matriz_consultar(
      id_proceso,
      proceso_riesgo,
      id_zona,
      zona,
      id_acti,
      actividades,
      id_tareas,
      tareas
    ) {
      // DECLARAR POR ACÁ EL ARRAY
      (async () => {
        await db
          .collection("matriz_riesgo")
          .where("em_id_tareas", "==", id_tareas)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.array_lista_peligros.unshift({
                proceso_riesgo: proceso_riesgo,
                id_proceso: id_proceso,
                zona: zona,
                id_zona: id_zona,
                actividades: actividades,
                id_acti: id_acti,
                tareas: tareas,
                id_tarea: id_tareas,

                id_peligro: doc.data().em_id_peligro,
                id_subcla: doc.data().em_id_subclasificacion,
                id_efectos_posibles: doc.data().em_id_efectos_posibles,

                descripcion: `${doc.data().em_descripcion}`,
                clasificacion: `${doc.data().em_clasificacion}`,
                tipo: `${doc.data().em_tipo}`,
                rutinario: `${doc.data().em_rutinario}`,
                subti: `${doc.data().em_subti}`,
                otro_subti: `${doc.data().em_otro_subti}`,

                efectos: [
                  doc.data().em_efecto1,
                  doc.data().em_efecto2,
                  doc.data().em_efecto3,
                  doc.data().em_efecto4,
                  doc.data().em_efecto5,
                  doc.data().em_efecto6,
                  doc.data().em_efecto7,
                  doc.data().em_efecto8,
                  doc.data().em_efecto9,
                  doc.data().em_efecto10,
                  doc.data().em_efecto11,
                  doc.data().em_efecto12,
                  doc.data().em_efecto13,
                  doc.data().em_efecto14,
                  doc.data().em_efecto15,
                  doc.data().em_efecto16,
                  doc.data().em_efecto17,
                  doc.data().em_efecto18,
                  doc.data().em_efecto19,
                  doc.data().em_efecto20,
                  doc.data().em_efecto21,
                  doc.data().em_efecto22,
                  doc.data().em_otro_efecto1,
                  doc.data().em_otro_efecto2,
                ],
                control_fuente: [
                  doc.data().em_control_fuente,
                  doc.data().em_control_fuente1,
                  doc.data().em_control_fuente2,
                  doc.data().em_control_fuente3,
                  doc.data().em_control_fuente4,
                  doc.data().em_control_fuente5,
                  doc.data().em_control_fuente6,
                  doc.data().em_control_fuente7,
                  doc.data().em_control_fuente8,
                  doc.data().em_control_fuente9,
                  doc.data().em_control_fuente10,
                  doc.data().em_control_fuente11,
                  doc.data().em_control_fuente12,
                  doc.data().em_control_fuente13,
                  doc.data().em_control_fuente14,
                  doc.data().em_control_fuente15,
                  doc.data().em_control_fuente16,
                  doc.data().em_control_fuente17,
                  doc.data().em_control_fuente18,
                  doc.data().em_control_fuente19,
                  doc.data().em_control_fuente20,
                  doc.data().em_control_fuente21,
                  doc.data().em_control_fuente22,
                  doc.data().em_control_fuente23,
                  doc.data().em_control_fuente24,
                  doc.data().em_control_fuente25,
                  doc.data().em_control_fuente26,
                  doc.data().em_control_fuente27,
                  doc.data().em_control_fuente28,
                  doc.data().em_control_fuente29,
                  doc.data().em_control_fuente30,
                  doc.data().em_control_fuente31,
                  doc.data().em_control_fuente32,
                  doc.data().em_control_fuente33,
                  doc.data().em_control_fuente34,
                ],
                control_medio: [
                  doc.data().em_control_medio,
                  doc.data().em_control_medio1,
                  doc.data().em_control_medio2,
                  doc.data().em_control_medio3,
                  doc.data().em_control_medio4,
                  doc.data().em_control_medio5,
                  doc.data().em_control_medio6,
                  doc.data().em_control_medio7,
                  doc.data().em_control_medio8,
                  doc.data().em_control_medio9,
                  doc.data().em_control_medio10,
                  doc.data().em_control_medio11,
                  doc.data().em_control_medio12,
                  doc.data().em_control_medio13,
                  doc.data().em_control_medio14,
                  doc.data().em_control_medio15,
                  doc.data().em_control_medio16,
                  doc.data().em_control_medio17,
                  doc.data().em_control_medio18,
                  doc.data().em_control_medio19,
                  doc.data().em_control_medio20,
                  doc.data().em_control_medio21,
                  doc.data().em_control_medio22,
                  doc.data().em_control_medio23,
                  doc.data().em_control_medio24,
                  doc.data().em_control_medio25,
                  doc.data().em_control_medio26,
                  doc.data().em_control_medio27,
                  doc.data().em_control_medio28,
                  doc.data().em_control_medio29,
                  doc.data().em_control_medio30,
                  doc.data().em_control_medio31,
                  doc.data().em_control_medio32,
                  doc.data().em_control_medio33,
                  doc.data().em_control_medio34,
                ],
                control_individuo: [
                  doc.data().em_control_individuo,
                  doc.data().em_control_individuo1,
                  doc.data().em_control_individuo2,
                  doc.data().em_control_individuo3,
                  doc.data().em_control_individuo4,
                  doc.data().em_control_individuo5,
                  doc.data().em_control_individuo6,
                  doc.data().em_control_individuo7,
                  doc.data().em_control_individuo8,
                  doc.data().em_control_individuo9,
                  doc.data().em_control_individuo10,
                  doc.data().em_control_individuo11,
                  doc.data().em_control_individuo12,
                  doc.data().em_control_individuo13,
                  doc.data().em_control_individuo14,
                  doc.data().em_control_individuo15,
                  doc.data().em_control_individuo16,
                  doc.data().em_control_individuo17,
                  doc.data().em_control_individuo18,
                  doc.data().em_control_individuo19,
                  doc.data().em_control_individuo20,
                  doc.data().em_control_individuo21,
                  doc.data().em_control_individuo22,
                  doc.data().em_control_individuo23,
                  doc.data().em_control_individuo24,
                  doc.data().em_control_individuo25,
                  doc.data().em_control_individuo26,
                  doc.data().em_control_individuo27,
                  doc.data().em_control_individuo28,
                  doc.data().em_control_individuo29,
                  doc.data().em_control_individuo30,
                  doc.data().em_control_individuo31,
                  doc.data().em_control_individuo32,
                  doc.data().em_control_individuo33,
                  doc.data().em_control_individuo34,
                ],

                nivel_eficiencia: doc.data().em_nivel_eficiencia,
                nivel_exposicion: doc.data().em_nivel_exposicion,
                nivel_probabilidad: doc.data().em_nivel_probabilidad,
                interpretacion: `${doc.data().em_interpretacion}`,
                nivel_consecuencia: doc.data().em_nivel_consecuencia,
                nivel_riesgo: doc.data().em_nivel_riesgo,
                interpretacion_nr: `${doc.data().em_interpretacion_nr}`,
                aceptabilidad: `${doc.data().em_aceptabilidad}`,

                num_expuestos: doc.data().em_num_expuestos,
                peor_consecuencia: `${doc.data().em_peor_consecuencia}`,

                eliminacion: `${doc.data().em_eliminacion}`,
                sustitucion: `${doc.data().em_sustitucion}`,
                controles_ing: `${doc.data().em_controles_ing}`,
                controles: `${doc.data().em_controles}`,
                equipos: `${doc.data().em_equipos}`,

                class_btn_outline: "",
                class_btn_alerts: "",
              });
            });
            this.delete_undefined();
            this.estilos_evaluacion_riesgo();
          });
        await NProgress.done();
        await NProgress.remove();
      })();
    },

    delete_undefined() {
      (async () => {
        for (let e = 0; e < this.array_lista_peligros.length; e++) {
          for (
            let i = 0;
            i < this.array_lista_peligros[e].control_fuente.length;
            i++
          ) {
            this.array_lista_peligros[e].control_fuente[
              i
            ] = `${this.array_lista_peligros[e].control_fuente[i]}`;
            if (
              this.array_lista_peligros[e].control_fuente[i] === "undefined" ||
              !this.array_lista_peligros[e].control_fuente[i]
            ) {
              this.array_lista_peligros[e].control_fuente.splice(i, 1);
            }
          }
        }
        for (let e = 0; e < this.array_lista_peligros.length; e++) {
          for (
            let i = 0;
            i < this.array_lista_peligros[e].control_medio.length;
            i++
          ) {
            this.array_lista_peligros[e].control_medio[
              i
            ] = `${this.array_lista_peligros[e].control_medio[i]}`;
            if (
              this.array_lista_peligros[e].control_medio[i] === "undefined" ||
              !this.array_lista_peligros[e].control_medio[i]
            ) {
              this.array_lista_peligros[e].control_medio.splice(i, 1);
            }
          }
        }
        for (let e = 0; e < this.array_lista_peligros.length; e++) {
          for (
            let i = 0;
            i < this.array_lista_peligros[e].control_individuo.length;
            i++
          ) {
            this.array_lista_peligros[e].control_individuo[
              i
            ] = `${this.array_lista_peligros[e].control_individuo[i]}`;
            if (
              this.array_lista_peligros[e].control_individuo[i] ===
                "undefined" ||
              !this.array_lista_peligros[e].control_individuo[i]
            ) {
              this.array_lista_peligros[e].control_individuo.splice(i, 1);
            }
          }
          if (
            this.array_lista_peligros[e].id_peligro === "undefined" ||
            !this.array_lista_peligros[e].id_peligro
          )
            this.array_lista_peligros[e].id_peligro = "";

          if (
            this.array_lista_peligros[e].id_subcla === "undefined" ||
            !this.array_lista_peligros[e].id_subcla
          )
            this.array_lista_peligros[e].id_subcla = "";

          if (
            this.array_lista_peligros[e].id_efectos_posibles === "undefined" ||
            !this.array_lista_peligros[e].id_efectos_posibles
          )
            this.array_lista_peligros[e].id_efectos_posibles = "";

          this.array_lista_peligros[e].efectos = this.array_lista_peligros[
            e
          ].efectos.filter(Boolean);
        }
        await this.mapear();
      })();
    },

    mapear() {
      (async () => {
        await this.array_lista_peligros.forEach((e) => {
          e.control_fuente = e.control_fuente.map((item) => {
            if (item === undefined || item === "undefined") {
            } else return item;
          });
        });
        await this.array_lista_peligros.forEach((e) => {
          e.control_medio = e.control_medio.map((item) => {
            if (item === undefined || item === "undefined") {
            } else return item;
          });
        });
        await this.array_lista_peligros.forEach((e) => {
          e.control_individuo = e.control_individuo.map((item) => {
            if (item === undefined || item === "undefined") {
            } else return item;
          });
        });
        await this.filtrar();
      })();
    },

    filtrar() {
      for (let e = 0; e < this.array_lista_peligros.length; e++) {
        this.array_lista_peligros[e].control_fuente = this.array_lista_peligros[
          e
        ].control_fuente.filter((dato) => {
          if (
            dato !== "" ||
            dato !== "undefined" ||
            dato !== undefined ||
            dato !== false ||
            dato !== NaN ||
            dato !== null
          ) {
            return dato;
          }
        });
      }
      for (let e = 0; e < this.array_lista_peligros.length; e++) {
        this.array_lista_peligros[e].control_medio = this.array_lista_peligros[
          e
        ].control_medio.filter((dato) => {
          if (
            dato !== "" ||
            dato !== "undefined" ||
            dato !== undefined ||
            dato !== false ||
            dato !== NaN ||
            dato !== null
          ) {
            return dato;
          }
        });
      }
      for (let e = 0; e < this.array_lista_peligros.length; e++) {
        this.array_lista_peligros[
          e
        ].control_individuo = this.array_lista_peligros[
          e
        ].control_individuo.filter((dato) => {
          if (
            dato !== "" ||
            dato !== "undefined" ||
            dato !== undefined ||
            dato !== false ||
            dato !== NaN ||
            dato !== null
          ) {
            return dato;
          }
        });
      }
    },

    estilos_evaluacion_riesgo() {
      for (let e = 0; e < this.array_lista_peligros.length; e++) {
        if (this.array_lista_peligros[e].nivel_eficiencia == "") {
          this.array_lista_peligros[e].nivel_eficiencia = 0;
          this.array_lista_peligros[e].nivel_exposicion = 0;
          this.array_lista_peligros[e].nivel_probabilidad = 0;
          this.array_lista_peligros[e].nivel_consecuencia = 0;
        }
        if (this.array_lista_peligros[e].nivel_probabilidad >= 24) {
          this.array_lista_peligros[e].interpretacion = "Muy alto";
          this.array_lista_peligros[e].class_btn_outline =
            "btn btn-outline-danger";
        }
        if (
          this.array_lista_peligros[e].nivel_probabilidad >= 10 &&
          this.array_lista_peligros[e].nivel_probabilidad <= 20
        ) {
          this.array_lista_peligros[e].interpretacion = "Alto";
          this.array_lista_peligros[e].class_btn_outline =
            "btn btn-outline-warning";
        }
        if (
          this.array_lista_peligros[e].nivel_probabilidad >= 6 &&
          this.array_lista_peligros[e].nivel_probabilidad <= 8
        ) {
          this.array_lista_peligros[e].interpretacion = "Medio";
          this.array_lista_peligros[e].class_btn_outline =
            "btn btn-outline-primary";
        }
        if (
          this.array_lista_peligros[e].nivel_probabilidad >= 0 &&
          this.array_lista_peligros[e].nivel_probabilidad <= 4
        ) {
          this.array_lista_peligros[e].interpretacion = "Bajo";
          this.array_lista_peligros[e].class_btn_outline =
            "btn btn-outline-success";
        }

        if (
          this.array_lista_peligros[e].nivel_consecuencia == "0" ||
          this.array_lista_peligros[e].nivel_probabilidad == 0
        ) {
          this.array_lista_peligros[e].nivel_riesgo = 20;
        } else {
          this.array_lista_peligros[e].nivel_riesgo =
            this.array_lista_peligros[e].nivel_probabilidad *
            this.array_lista_peligros[e].nivel_consecuencia;
        }

        if (
          this.array_lista_peligros[e].nivel_riesgo >= 600 &&
          this.array_lista_peligros[e].nivel_riesgo <= 4000
        ) {
          this.array_lista_peligros[e].interpretacion_nr = "l";
          this.array_lista_peligros[e].aceptabilidad = "No Aceptable";

          this.array_lista_peligros[e].class_btn_alerts =
            "btn btn-danger btn-block";
        } else if (
          this.array_lista_peligros[e].nivel_riesgo >= 150 &&
          this.array_lista_peligros[e].nivel_riesgo <= 500
        ) {
          this.array_lista_peligros[e].interpretacion_nr = "ll";
          this.array_lista_peligros[e].aceptabilidad =
            "Aceptable con Control Específico";

          this.array_lista_peligros[e].class_btn_alerts =
            "btn btn-warning btn-block";
        } else if (
          this.array_lista_peligros[e].nivel_riesgo >= 40 &&
          this.array_lista_peligros[e].nivel_riesgo <= 120
        ) {
          this.array_lista_peligros[e].interpretacion_nr = "lll";
          this.array_lista_peligros[e].aceptabilidad = "Mejorable";

          this.array_lista_peligros[e].class_btn_alerts =
            "btn btn-primary btn-block";
        } else if (
          this.array_lista_peligros[e].nivel_riesgo == 0 ||
          this.array_lista_peligros[e].nivel_riesgo == 20
        ) {
          this.array_lista_peligros[e].interpretacion_nr = "lV";
          this.array_lista_peligros[e].aceptabilidad = "Aceptable";

          this.array_lista_peligros[e].class_btn_alerts =
            "btn btn-success btn-block";
        }
      }
    },

    consultar_lista_clientes(id_cliente) {
      this.array_lista_peligros = [];
      NProgress.start();
      this.id_cliente_matriz = `${id_cliente}`;
      this.excel_proceso_consulta(this.id_cliente_matriz);
    },

    // PROCESO PARA COPIAR LA MATRIZ
    proceso_copiar_matriz() {
      (async () => {
        NProgress.start();
        if (
          this.$store.state.msp_c_key &&
          this.$store.state.msp_c_key_cliente_iper
        ) {
          this.arr_temp_procesos = [];
          for (let e = 0; e < this.array_lista_peligros.length; e++) {
            this.arr_temp_procesos.push({
              proceso_riesgo: this.array_lista_peligros[e].proceso_riesgo,
              zona: this.array_lista_peligros[e].zona,
              actividades: this.array_lista_peligros[e].actividades,
              tareas: this.array_lista_peligros[e].tareas,
            });
          }
          let set = new Set(this.arr_temp_procesos.map(JSON.stringify));
          this.arr_temp_procesos = Array.from(set).map(JSON.parse);
          // REGISTRAR LOS PZAT A LA DB
          await this.registrar_proceso();
        } else {
          $("#modal_mostrar_matriz").modal("hide");
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Aún no ha registrado un Centro de Trabajo.",
            showConfirmButton: false,
            timer: 1500,
          });
          await NProgress.done();
          await NProgress.remove();
          console.log("No ha registrado un cliente.");
          this.$store.state.estado_navbar_matriz_peligro =
            "registro_centro_trabajo";
          await this.$router.push("/matriz-peligro");
        }
      })();
    },

    registrar_proceso() {
      (async () => {
        for (let e = 0; e < this.arr_temp_procesos.length; e++) {
          const newProcesoRef = db.collection("proceso").doc();
          const id_proceso = newProcesoRef.id;

          const newZonaRef = db.collection("zona").doc();
          const id_zona = newZonaRef.id;

          const newActividadRef = db.collection("actividades").doc();
          const id_acti = newActividadRef.id;

          const newTareaRef = db.collection("tareas").doc();
          const id_tarea = newTareaRef.id;

          let proceso_riesgo = this.arr_temp_procesos[e].proceso_riesgo;
          let zona = this.arr_temp_procesos[e].zona;
          let actividades = this.arr_temp_procesos[e].actividades;
          let tareas = this.arr_temp_procesos[e].tareas;

          db.collection("proceso").doc(id_proceso).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_proceso_riesgo: proceso_riesgo,
          });

          db.collection("zona").doc(id_zona).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_zona: zona,
          });

          db.collection("actividades").doc(id_acti).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_id_zona: id_zona,
            em_actividades: actividades,
          });

          db.collection("tareas").doc(id_tarea).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_id_zona: id_zona,
            em_id_acti: id_acti,
            em_tareas: tareas,
          });
          this.copiar_lista_procesos(
            id_proceso,
            id_zona,
            id_acti,
            id_tarea,
            proceso_riesgo,
            zona,
            actividades,
            tareas
          );
          this.registrar_peligro(
            id_proceso,
            id_zona,
            id_acti,
            id_tarea,
            proceso_riesgo,
            zona,
            actividades,
            tareas
          );
        }
        await NProgress.done();
        await NProgress.remove();
        $("#modal_mostrar_matriz").modal("hide");
        // DETECTAR CUANDO UN MODAL SE CIERRA Y EJECUTAR UNA FUNCIÓN
        $("#modal_mostrar_matriz").on("hidden.bs.modal", () => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Datos Copiados Correctamente",
            showConfirmButton: false,
            timer: 1500,
          });
        });
        this.$store.state.estado_navbar_matriz_peligro = "seleccionar_proceso";
        await this.$router.push("/matriz-peligro");
      })();
    },

    copiar_lista_procesos(
      id_proceso,
      id_zona,
      id_acti,
      id_tareas,
      proceso_peligro,
      zona,
      acti,
      tarea
    ) {
      this.$store.state.msp_procesos_iper.forEach((i) => {
        if (i.p_nuevo_proceso == proceso_peligro) {
        } else {
          this.$store.state.msp_procesos_iper.push({
            p_nuevo_proceso: proceso_peligro,
          });
        }
      });

      this.$store.state.msp_zonas_iper.forEach((i) => {
        if (i.p_nuevo_zona == zona) {
        } else {
          this.$store.state.msp_zonas_iper.push({
            p_nuevo_zona: zona,
          });
        }
      });
      this.$store.state.msp_actividades_iper.forEach((i) => {
        if (i.p_nuevo_actividad == acti) {
        } else {
          this.$store.state.msp_actividades_iper.push({
            p_nuevo_actividad: acti,
          });
        }
      });
      this.$store.state.msp_tareas_iper.forEach((i) => {
        if (i.p_nuevo_tareas == tarea) {
        } else {
          this.$store.state.msp_tareas_iper.push({
            p_nuevo_tareas: tarea,
          });
        }
      });
      this.$store.state.msp_lista_procesos.unshift({
        id: this.$store.state.msp_c_key,
        id_ciente_iper: this.$store.state.msp_c_key_cliente_iper,
        proceso_riesgo: proceso_peligro,
        id_proceso: id_proceso,
        zona: zona,
        id_zona: id_zona,
        actividad: acti,
        id_acti: id_acti,
        tarea: tarea,
        id_tareas: id_tareas,
        rutinario_peligro: "",
        id_matriz: [],
      });
      let set = new Set(
        this.$store.state.msp_lista_procesos.map(JSON.stringify)
      );
      this.$store.state.msp_lista_procesos = Array.from(set).map(JSON.parse);
    },

    registrar_peligro(
      id_proceso,
      id_zona,
      id_acti,
      id_tarea,
      proceso_riesgo,
      zona,
      actividades,
      tareas
    ) {
      (async () => {
        for (let e = 0; e < this.array_lista_peligros.length; e++) {
          if (
            this.array_lista_peligros[e].proceso_riesgo == proceso_riesgo &&
            this.array_lista_peligros[e].zona == zona &&
            this.array_lista_peligros[e].actividades == actividades &&
            this.array_lista_peligros[e].tareas == tareas
          ) {
            let newMatrizRef = db.collection("matriz_riesgo").doc();
            let id_matriz = newMatrizRef.id;
            db.collection("matriz_riesgo").doc(id_matriz).set({
              em_id_cliente_iper: this.$store.state.msp_c_key_cliente_iper,
              em_id_cliente: this.$store.state.msp_c_key,
              em_id_proceso: id_proceso,
              em_id_zona: id_zona,
              em_id_acti: id_acti,
              em_id_tareas: id_tarea,

              em_proceso: proceso_riesgo,
              em_zona: zona,
              em_actividad: actividades,
              em_tarea: tareas,

              em_id_peligro: this.array_lista_peligros[e].id_peligro,
              em_id_subclasificacion: this.array_lista_peligros[e].id_subcla,
              em_id_efectos_posibles: this.array_lista_peligros[e]
                .id_efectos_posibles,

              em_descripcion: this.array_lista_peligros[e].descripcion,
              em_clasificacion: this.array_lista_peligros[e].clasificacion,
              em_tipo: this.array_lista_peligros[e].tipo,
              em_rutinario: this.array_lista_peligros[e].rutinario,

              em_efecto_posible: this.array_lista_peligros[e].efectos,
              em_c_fuente: this.array_lista_peligros[e].control_fuente,
              em_c_medio: this.array_lista_peligros[e].control_medio,
              em_c_individuo: this.array_lista_peligros[e].control_individuo,
              em_antecedente: "",

              em_nivel_eficiencia: this.array_lista_peligros[e]
                .nivel_eficiencia,
              em_nivel_exposicion: this.array_lista_peligros[e]
                .nivel_exposicion,
              em_nivel_probabilidad: this.array_lista_peligros[e]
                .nivel_probabilidad,
              em_interpretacion: this.array_lista_peligros[e].interpretacion,
              em_nivel_consecuencia: this.array_lista_peligros[e]
                .nivel_consecuencia,
              em_nivel_riesgo: this.array_lista_peligros[e].nivel_riesgo,
              em_interpretacion_nr: this.array_lista_peligros[e]
                .interpretacion_nr,
              em_aceptabilidad: this.array_lista_peligros[e].aceptabilidad,

              em_class_btn_outline: this.array_lista_peligros[e]
                .class_btn_outline,
              em_class_btn_alerts: this.array_lista_peligros[e]
                .class_btn_alerts,

              em_num_expuestos: this.array_lista_peligros[e].num_expuestos,
              em_peor_consecuencia: this.array_lista_peligros[e]
                .peor_consecuencia,

              em_eliminacion: this.array_lista_peligros[e].eliminacion,
              em_sustitucion: this.array_lista_peligros[e].sustitucion,
              em_control_ingenieria: this.array_lista_peligros[e].controles_ing,
              em_controles_admin: this.array_lista_peligros[e].controles,
              em_epp: this.array_lista_peligros[e].equipos,
            });
            for (
              let element = 0;
              element < this.$store.state.msp_lista_procesos.length;
              element++
            ) {
              if (
                this.$store.state.msp_lista_procesos[element].id_tareas ==
                id_tarea
              )
                this.$store.state.msp_lista_procesos[element].id_matriz.push(
                  id_matriz
                );
            }
          }
        }
        await NProgress.done();
        await NProgress.remove();
      })();
    },

    limpiarConsulta() {
      this.sector_existente = "";
      this.regional_existente = "";
      this.departamento_existente = "";
      this.ciudades_existente = "";
      this.clientes_existente = "";
    },
  },
};
</script>